export default __webpack_public_path__ + "assets/partly-cloudy-night-snow.074350e6.svg";